import 'globals';

(function($, window, document, pageLoadedQueue) {
	pageLoadedQueue.push(function() {
        $('.counter__digit').each(function() {
            var duration = $(this).data('duration');
            $(this).prop('counter', 0).animate({
                counter: $(this).text()
            }, {
                duration: duration,
                easing: 'swing',
                step: function(now) {
                    $(this).text(Math.ceil(now));
                }
            });
        });
    });
})(jQuery, window, document, window.pageLoadedQueue);
